import GroupsList from './GroupsList';
import GroupsListContainer from './GroupsList.container';
export default GroupsListContainer(GroupsList);
